/**
 *   Generated file. Do not edit
 */

import { createEnumConverter } from '@iotize/tap/service/core';
import { createEnumArrayConverter } from '@iotize/tap/service/core';
import { FixedSizeEnumConverter } from '@iotize/tap/client/impl';
import { ArrayConverter } from '@iotize/tap/client/impl';
import { EnumListConverter } from '@iotize/tap/client/impl';
import { SlaveServerRawConfigConverter } from './converters';

export const slaveServerRawConfig = new SlaveServerRawConfigConverter();
